// components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, role }) {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (!currentUser?.type || currentUser.type !== role) {
    return <Navigate to="/" replace />;
  }

  return children;
}
